import Title from "./UI/Title";
import PageContent from "./UI/PageContent";

const WORK_ITEMS = [
    {
    title: "Snowball - Lead Developer frontend",
    date: "2026 - Now",
    description:
      "Own the entire frontend ecosystem and product UI (Next.js, React, Tailwind) of the B2C financial apps, while leveraging AI-powered automation (skills, agents, CI/CD) to accelerate development and streamline internal collaboration and delivery.",
    tags: ["AI", "React", "Next", "Tailwind"],
  },
  {
    title: "Bump - Fullstack Developer",
    date: "2023 - 2026",
    description:
      "Developed digital products including a B2B platform for managing EV fleets and charging station networks as fullstack developer (React, .Net, PostgresSQL).",
    tags: ["AI", "React", ".NET", "PostgreSQL"],
  },
  {
    title: "Majelan - Frontend Developer",
    date: "2022 - 2023",
    description:
      "Built web app, mobile app, back office, and integrated audio player, improving engagement and implementing scalable, testable front-end architectures (using React, Next.js and React Native).",
    tags: ["React", "Next.js", "React Native"],
  },
  {
    title: "Immersiv.io - Digital & Communication Manager",
    date: "2020 - 2021",
    description:
      "Led digital strategy and web projects, including website redesign, SEO, and product-focused marketing for immersive AR experiences.",
    tags: ["SEO", "Web", "Product"],
  },
];

const EDUCATION_ITEMS = [
  {
    title: "O'Clock - Fullstack Javascript Developer",
    date: "2021 - 2022",
    description:
      "Intensive 800-hour program covering frontend (React, HTML/CSS), backend (Node.js, Express, SQL), data, and web project management workflows.",
    tags: ["React", "Node.js", "SQL"],
  },
  {
    title: "EFAP - MBA Digital Marketing & Business",
    date: "2018 - 2019",
    description:
      "Specialized in digital marketing and e-commerce: web project management, online acquisition (SEO, Ads, CRM), and digital innovation (startups, IoT, AI).",
    tags: ["Marketing", "E-commerce"],
  },
  {
    title: "Paris V Descartes - M2 Business Law",
    date: "2013 - 2017",
    description:
      "Advanced studies (Licence and Master) in private and business law, with a tax specialization.",
    tags: ["Law", "Business"],
  },
];

function Journey() {
  return (
    <PageContent>
      <div className="section-stack">
        <div>
          <Title title="🎯 Work Experience" />
          <ol className="timeline-rail mt-10 md:mt-12">
            {WORK_ITEMS.map((item) => (
              <TimelineItem key={item.title} {...item} />
            ))}
          </ol>
        </div>

        <div>
          <Title title="📚 Educational" />
          <ol className="timeline-rail mt-10 md:mt-12">
            {EDUCATION_ITEMS.map((item) => (
              <TimelineItem key={item.title} {...item} />
            ))}
          </ol>
        </div>
      </div>
    </PageContent>
  );
}

export default Journey;

export const TimelineItem = ({ title, date, description, tags = [] }) => {
  return (
    <li className="timeline-item">
      <div className="timeline-dot" aria-hidden />

      <article className="timeline-card">
        <header className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2">
          <p className="font-semibold text-ink text-base md:text-lg tracking-tight">
            {title}
          </p>
          <span className="text-xs md:text-sm font-medium text-muted shrink-0">
            {date}
          </span>
        </header>

        <p className="mt-4 text-sm md:text-base text-muted leading-relaxed">
          {description}
        </p>

        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-6">
            {tags.map((tag) => (
              <span key={tag} className="tag-pill">
                {tag}
              </span>
            ))}
          </div>
        )}
      </article>
    </li>
  );
};
